import { defaultAllSelection } from "services/constants/selections";

const isRealCompany = (companyId) =>
  companyId != null && String(companyId) !== "" && String(companyId) !== String(defaultAllSelection);

// User Group picker on the employee forms. A group only applies to an
// employee when it has a role in the employee's company, so the list is
// scoped to the company chosen on the form, falling back to the topbar
// company. With neither known (or "All" selected) every group is listed.
export const userGroupDetailsUrl = (domain, formCompanyId, topbarCompanyId) => {
  const companyId = [formCompanyId, topbarCompanyId].find(isRealCompany);
  const base = `${domain}basic/user-group/details/`;
  return companyId === undefined ? base : `${base}?company_id=${companyId}`;
};

// An employee can belong to several user groups, so the form keeps
// `user_group` as an array of ids. Older records may still carry a single id.
export const toUserGroupIds = (value) => {
  if (Array.isArray(value)) return value.filter((id) => id != null && id !== "");
  return value == null || value === "" ? [] : [value];
};

// Prefer the complete membership fields over the legacy single-group value.
// An explicitly empty list means the employee has no assigned groups.
export const employeeUserGroupIds = (employee = {}) => {
  if (Array.isArray(employee.user_group_ids)) {
    return toUserGroupIds(employee.user_group_ids);
  }
  if (Array.isArray(employee.user_groups)) {
    return toUserGroupIds(employee.user_groups.map((group) => group?.id));
  }
  return toUserGroupIds(employee.user_group);
};

export const userGroupOptions = (groups = []) =>
  groups.map((group) => ({ ...group, label: group.name }));

export const selectedUserGroupLabels = (options, ids) => {
  const selectedIds = toUserGroupIds(ids).map(String);
  return options
    .filter((option) => selectedIds.includes(String(option.id)))
    .map((option) => option.label);
};

export const userGroupIdsFromLabels = (options, labels) =>
  options
    .filter((option) => labels.includes(option.label))
    .map((option) => option.id);

export const userGroupRequired = (ids) =>
  toUserGroupIds(ids).length > 0 || "User Group name is required";
